<template>
  <i class="tm-ticks">
    <i v-for="(tick, i) in ticks" :key="i" :data-time="tick.time" />
  </i>
</template>

<script>
export default {
  name: 'tm-ticks',
  props: {
    ticks: { type: Array },
  },
};
</script>

<style lang="scss">
.tm-grid > .tm-row > .tm-ticks {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  border-top: 1px solid var(--tm-rulerColour);

  > i {
    align-self: flex-start;
    width: 1px;
    height: 5px;
    background: var(--tm-rulerColour);

    &[data-time] {
      height: 10px;
      position: relative;

      &:before {
        content: attr(data-time) '';
        position: absolute;
        top: 10px;
        color: var(--tm-rulerColour);
        font-size: 12px;
        display: block;
      }
    }

    &:last-child {
      &[data-time] {
        &:before {
          text-align: right;
          right: 0;
        }
      }
    }
  }
}
</style>
